<template>
  <ValidationProvider
    :rules="rules"
    v-slot="{ invalid, failedRules, touched, failed }"
    class="field"
    :vid="id"
  >
    <!-- Input for edit form -->
    <input
      v-if="!disabled && !readOnly"
      :required="required"
      role="textbox"
      :aria-label="name"
      v-model="innerValue"
      :type="type"
      :id="id"
      :name="name"
      :maxlength="maxLength"
      class="field__input"
      :class="failed && (failedRules.required || failedRules.max || failedRules.maximumValidateNumber || failedRules.regex || touched) || showIcon === 'iataError' || failedRules[showIcon]
          ? 'border-danger'
          : ''
      "
      @keyup="emitInnerValue(innerValue)"
      @blur="$emit('blur', innerValue)"
      autocomplete="off"
      placeholder=" "
    />
    <!-- Input edit form readonly -->
    <input
      v-else-if="readOnly"
      role="textbox"
      :aria-label="name"
      v-model="innerValue"
      :type="type"
      :id="id"
      :name="name"
      :maxlength="maxLength"
      class="field__input"
      autocomplete="off"
      placeholder=" "
      readonly="readonly"
    />
    <!-- Input no-edit form -->
    <input
      v-else
      role="textbox"
      :aria-label="name"
      :type="type"
      :id="id"
      :name="name"
      :maxlength="maxLength"
      class="field__input"
      :class="invalid && touched ? 'border-danger' : ''"
      autocomplete="off"
      placeholder=" "
      :value="innerValue !== '' && innerValue !== null ? innerValue : translate('ppNotSpecified')"
      :style="{ color: innerValue !== '' && innerValue !== null ? 'black' : '#cccccc' }"
      :disabled="disabled"
    />
    <ClipboardCopy v-if='value && showClipBoardCopy' :showText="false" :text="value" class="clipboard-copy"/>
    <i
      v-if="showIcon && touched && (showIcon === 'iataError' || failedRules[showIcon])"
      class="input-icon icon-alert-circle field__error"
    />
    <label
      v-if="responsiveLabelStyle"
      :for="id"
      class="field__labelResponsive"
      :class="failed && innerValue && touched ? 'text-danger' : ''"
      :disabled="disabled"
      >{{ label }}</label
    >
    <label
      v-if="!responsiveLabelStyle"
      :for="id"
      class="field__label"
      :class="[isCorporate ? 'customLeft' : '', failed && innerValue && touched || showIcon === 'iataError' || failedRules[showIcon] ? 'text-danger' : '']"
      :disabled="disabled"
      >{{ label }}</label
    >
    <div v-if="failedRules.required" class="field__error">{{ translate('rwThisIsRequired') }}</div>
    <div v-if="failedRules.email && touched" class="field__error">
      {{ translate('rwEmailFormatIncorrect') }}
    </div>
    <div v-if="failedRules.max" class="field__error">
      {{ translate('rwFieldNoLongerThan', undefined, rules.max) }}
    </div>
    <div v-if="failedRules.regex" class="field__error">
      {{ translate(regexErrorMessage) }}
    </div>
    <div v-if="failedRules.maximumValidateNumber" class="field__error">
      {{ translate('errLoNotEnoughPoints') }}
    </div>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'
import ClipboardCopy from '@/components/ClipboardCopy'

export default {
  name: 'TextField',
  components: {
    ValidationProvider,
    ClipboardCopy
  },
  props: {
    id: {
      type: String,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: ''
    },
    rules: {
      type: [Object, String],
      default: ''
    },
    disabled: {
      type: Boolean,
      defaultValue: false
    },
    hideIcon: {
      type: Boolean,
      default: false
    },
    responsiveLabelStyle: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: String,
      default: ''
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    maxLength: {
      type: Number,
      default: -1
    },
    regexErrorMessage: {
      type: String,
      default: 'chInvalidFormat'
    },
    showClipBoardCopy: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value(newValue) {
      this.innerValue = newValue
    }
  },
  data() {
    return {
      innerValue: this.value,
      isCorporate: false
    }
  },
  methods: {
    emitInnerValue(newValue) {
      this.$emit('changed', newValue)
    }
  },
  created() {
    if (this.type === 'number') {
      console.log(this.id)
    }
    if (this.id === 'corporateEmail' || this.id === 'corporateID') {
      this.isCorporate = true
    }
  }
}
</script>

<style lang="scss" scoped>
.field {
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 1rem 0;
  width: 100%;
  row-gap: 0.1rem;

  &__input {
    position: relative;
    font-size: 1.4rem;
    padding: 0.75rem 3.5rem 0.75rem 1rem;
    border: solid 1px color('silver');
    border-radius: 0.4rem;
    width: 100%;
    text-overflow: ellipsis !important;

    &[disabled] {
      border: 0;
      background-color: white;
    }
  }

  &__label {
    max-width: 95%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    position: absolute;
    background: white;
    top: 1.85rem;
    left: 1rem;
    font-size: 1.4rem;
    transition: top 200ms ease-in, left 200ms ease-in, font-size 200ms ease-in;
  }

  &__labelResponsive {
    position: absolute;
    background: white;
    top: 1.85rem;
    left: 1rem;
    font-size: 1.4rem;
    transition: top 200ms ease-in, left 200ms ease-in, font-size 200ms ease-in;
    white-space: nowrap;
    max-width: 90%;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__error {
    color: crimson;
    font-size: 1.1rem;
  }
}

.field__input:focus ~ .field__label,
.field__input:not(:placeholder-shown).field__input:not(:focus) ~ .field__label {
  top: 0;
  font-size: 1.1rem;
}
.field__input:focus ~ .field__labelResponsive,
.field__input:not(:placeholder-shown).field__input:not(:focus) ~ .field__labelResponsive {
  top: 0;
  font-size: 1.1rem;
}
.input-icon {
  position: absolute !important;
  margin: 1.1rem !important;
  right: 0 !important;
  width: 20px;
  height: 20px;
  font-size: 20px;
}
input:focus {
  outline: none;
}
.clipboard-copy {
  position: absolute;
  right: 1rem;
  bottom: 2rem;
}
.customLeft {
      left: 0;
}

html[dir="rtl"] {
  input {
    padding: 0.75rem 0rem 0.75rem 1rem !important;
  }
  .field__label {
    right: 0rem;
    top: -1rem !important;
  }
}
</style>
